import script from "./AuthView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthView.vue?vue&type=script&setup=true&lang=ts"

import "./AuthView.vue?vue&type=style&index=0&id=b8face70&lang=css"

const __exports__ = script;

export default __exports__